import {
  FreeLink as LibFreeLink,
  pickFreeLinkSettings
} from '@elfsight/widget-free-link';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../constants';

export function FreeLink() {
  const settings = useSettings();
  const freeLinkSettings = pickFreeLinkSettings(settings);

  return (
    <LibFreeLink
      {...freeLinkSettings}
      appAlias={meta.alias}
      appName={meta.name}
      style={{ link: { marginTop: '20px' } }}
    />
  );
}
